<template>
    <div>
        <vs-row class="p-4">
            <vs-col w="12" class="text-center mb-5 mt-4">
                <span class="font-medina"><strong>¿Cómo te gustaría ingresar?</strong></span>
            </vs-col>
            <vs-col sm="12" lg="6" class="cardSize">  
                <vs-card @click="rutaRol('profesor')">
                    <template #title>
                        <div class="text-center">
                            <h3>PROFESOR</h3>
                        </div>
                    </template>
                    <template #img>
                    <img src="/img/profesor.png" alt="">
                    </template>
                    <template #text>
                        <p></p>
                    </template>
                </vs-card>
            </vs-col>
            <vs-col sm="12" lg="6" class="cardSize">  
                <vs-card @click="rutaRol('alumno')">
                    <template #title>
                        <div class="text-center">
                            <h3>ALUMNO</h3>
                        </div>
                    </template>
                    <template #img>
                        <img src="/img/alumno.png" alt="">
                    </template>
                    <template #text>
                        <p>
                        </p>
                    </template>
                </vs-card>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import { window } from 'rxjs/operators'
export default {
    methods:{
        rutaRol(rol){
            console.log("entro")
            if(rol == 'profesor'){
                location.href = '/panel-docentes'
            }else if(rol == 'alumno'){
                location.href = '/v2/home-familiar'
            }
        }
    }
}
</script>

<style>
    .font-medina{
        font-size: 24px;
    }
    .cardSize .vs-card{
        margin: auto;
        max-width: 400px !important;
    }

    .cardSize .vs-card .vs-card__img{
        max-height: 300px;
    }
</style>